import React, { Component } from 'react';
import { connect } from 'react-redux';

import Header from 'components/Header';
import Soundbox from 'components/Admin/Soundbox/Soundbox';

import Paths from 'paths';

class Soundboxs extends Component{

    render() {
        return (
            <section id="la-soundbox-container">
                <Header returnLink={Paths.PATH_ADMIN_HOME}/>
                <h1>Toutes les soundboxs</h1>
                <div className={'soundbox-grid-bar-container soundboxs-list'}>
                    {
                        this.props.soundboxs.map((soundbox) => <Soundbox 
                            soundbox={soundbox} 
                            title={this.props.bundles.find(bundle => bundle.id === soundbox.id).title}
                            key={soundbox.id}/>
                        )
                    }
                </div>
            </section>

        )
    }
}

const mapStateToProps = (state) => {
    return {
        soundboxs: state.soundboxs,
        bundles: state.bundles,
    }
};

export default connect(mapStateToProps, null)(Soundboxs);
